module.exports = __webpack_public_path__ + "img/16d001-24.b44e902f.jpg";